export enum AuthQueryParamKeys {
  PLAN = 'plan',
  PROMO = 'promo',
  EMULATOR = 'emulator',
}

export enum PlanParamValues {
  FREE = 'free',
  STUDENT = 'student',
  MARKETPLACE = 'marketplace',
}
